module.exports = "/_next/static/images/as-caaf405e70cccb4c0f966ba16afc08fc.svg";